module.exports = __webpack_public_path__ + "img/s1.b0bf55a6.png";